module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8CAMAAACn4e/8AAAATlBMVEUAak4DaU45W0t5S0eqPUXQNEPoLUL0KkEVZU2ESEffL0ILZ016SkfpLUJPVUreMEJOVkoCaU56SkgKaE6kP0alP0UWZE2jP0UBak54S0gdc1i5AAAA3ElEQVR4Ae3XhW2FMQwE4Avez5jS/otWXG4i2c+ifAOE4Yyu67rvnA8xZTKnGLzDIwzjxE+mcYC2eVn5zRpmqNom/mI/oOe8+IflhJK78E/lhorzif8oJzRc/NcCBRsrDojNOyv2GVILqwKEnldWrQNkRjYYIeImNpgcJDybeEgENgmQiGwSIZHYJEEis0mGBBuZdGKyXLYbb3+E7S+j/bNi/0CaPPUY5J+W/fdrHyRsI5FNuMNZ+I+X8/GB++WGknPhH8Ir9Gx7vQiSm8PKb9a32b4wtS2xu67r3gEi+yXONQlOWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/bd.png
// module id = QTa2
// module chunks = 0